import { Circle } from "../../../ui";

export default function FilterSidebar({
  sections,
  activeFilter,
  onFilterChange,
}) {
  return (
    <aside className="support-tickets-sidebar">
      {sections.map((section) => (
        <div key={section.title} role="group" aria-label={section.title}>
          <div className="support-sidebar-section" aria-hidden="true">
            {section.title}
          </div>

          {section.items.map((item) => {
            const Icon = item.icon || Circle;

            return (
              <button
                key={item.key}
                type="button"
                className={`support-sidebar-item ${
                  activeFilter === item.key ? "active" : ""
                }`}
                aria-pressed={activeFilter === item.key}
                onClick={() => onFilterChange(item.key)}
              >
                <div className="support-sidebar-left">
                  <Icon size={15} aria-hidden="true" />
                  <span>{item.label}</span>
                </div>

                {item.count !== undefined && (
                  <span
                    className={`support-count-badge ${
                      item.badgeClassName || ""
                    }`}
                  >
                    {item.count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      ))}
    </aside>
  );
}
